import {useEffect, useState} from 'react'
import DataTableList from '../../components/DataTableList'
import axios from 'axios'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {ADMIN_ALL_REQUESTED_DEVICES_HEADERS} from '../../../../constants/RoleConstants'
import {ActionDefaults} from '../../modules/accounts/components/CRUDWrapper/DefaultActions'
import ChangeStatusModal from '../../components/modals/ChangeStatusModal'
import {DEVICE_REQUEST_STATUS_CONSTANT} from '../../../../constants/StatusConstants'
import {StatusOptionComponentModel} from '../../../../entities/component.entity'
import {toast} from 'react-toastify'
import {DeviceModel} from '../../../../entities/device.entity'
import {useNavigate} from 'react-router-dom'
import MetaTags from '../../../../meta/MetaTags'

const actions = [ActionDefaults.viewProfile, ActionDefaults.changeStatus]

const RequestedDeviceListing = () => {
  const [devices, setDevices] = useState<DeviceModel[]>([])
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [selectedDeviceRequest, setSelectedDeviceRequest] = useState<any>(null) // ✅ Correct
  const navigate = useNavigate()

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.GET_ALL_DEVICES_REQUESTED_BY_DOCTORS())
        setDevices(response.data?.data?.devices)
      } catch (error) {
        // Add Error Component
      }
    }
    fetchDevices()
  }, [])

  // handle actions function
  const handleActionPerformed = async (actionType: any, row: any) => {
    switch (actionType.name) {
      case 'VIEW':
        navigate(`/doctor-details/${row?.Doctor?.uuid}`)
        break
      case 'CHANGE_STATUS':
        setSelectedDeviceRequest(row)
        setIsStatusModalOpen(true) // Open modal
        break
      default:
        console.log('')
    }
  }

  const handleStatusChange = async (values: any, resetForm: () => void) => {
    try {
      const response = await axios.put(
        API_ENDPOINTS.UPDATE_DEVICE_STATUS(selectedDeviceRequest?.id),
        {
          status: values.status,
          doctor_id: selectedDeviceRequest?.doctor_id,
        }
      )
      toast.success(response?.data?.message)

      resetForm()
      setIsStatusModalOpen(false) // Close modal after submission
      // Update the local state for devices after status change
      setDevices((prevDevices) =>
        prevDevices.map((device) =>
          device.id === selectedDeviceRequest?.id ? {...device, status: +values.status} : device
        )
      )
    } catch (error) {
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      } else if (error instanceof Error) {
        toast.error(error.message)
      } else {
        toast.error('An unexpected error occurred')
      }
    }
  }

  const statuses: StatusOptionComponentModel[] = [
    {value: DEVICE_REQUEST_STATUS_CONSTANT.PENDING, label: 'Pending', disabled: true},
    {value: DEVICE_REQUEST_STATUS_CONSTANT.ACCEPTED, label: 'Accepted'},
    {value: DEVICE_REQUEST_STATUS_CONSTANT.REJECTED, label: 'Rejected'},
  ]

  return (
    <>
        <MetaTags title={'Device List'} />

      {isStatusModalOpen && selectedDeviceRequest !== null && (
        <ChangeStatusModal
          isOpen={isStatusModalOpen}
          onClose={() => setIsStatusModalOpen(false)}
          handleSubmit={handleStatusChange}
          currentStatus={selectedDeviceRequest?.status || 0}
          statuses={statuses}
        />
      )}

      <DataTableList
        showAddButton={false}
        title={'Device List'}
        columns={ADMIN_ALL_REQUESTED_DEVICES_HEADERS}
        data={devices}
        actions={actions}
        onAction={handleActionPerformed}
      />
    </>
  )
}

export default RequestedDeviceListing
